import { lintWarning } from "./utils";

var linter = function linter(key, value, info) {
  if (key === 'animation') {
    if (info.hashId && value !== 'none') {
      lintWarning("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
  }
};

export default linter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs/es/linters/hashedAnimationLinter.js
// module id = 1391
// module chunks = 0